import {
  getBuildingType,
  getNumberOfBedrooms,
  getPropertyBuiltYear,
  getRiskAddress,
  getRoofMaterial,
  getWallMaterial,
  isFreestandingAboveGround,
} from 'scenes/home/selectors';
import { HomeFunnelState } from 'scenes/home/types';
import { EstimatedSumInsuredProfile } from 'scenes/common/api/quote/estimatedSumInsured/types';
import { mapBuildingTypeDetails } from 'scenes/home/api/quote/marshaller/building';

export const mapEstimatedSumInsuredProfile = (
  funnelState: HomeFunnelState
): EstimatedSumInsuredProfile => {
  const { postcode, state } = getRiskAddress(funnelState);
  return {
    postcode,
    state,
    building: {
      roof: getRoofMaterial(funnelState),
      type: getBuildingType(funnelState),
      wall: getWallMaterial(funnelState),
      year: getPropertyBuiltYear(funnelState),
      ...mapBuildingTypeDetails(funnelState),
      isAboveGround: isFreestandingAboveGround(funnelState),
      numberOfRooms: getNumberOfBedrooms(funnelState),
    },
  };
};
